module.exports = __webpack_public_path__ + "img/ic_32_gender_woman-active.efe35c4a.svg";